import { createFileRoute } from "@tanstack/react-router";
import { signInRoute, SignInRoute } from "@/features/account-access";

export const Route = createFileRoute("/sign-in")({
    validateSearch: signInRoute.validateSearch,
    ssr: signInRoute.ssr,
    head: signInRoute.head,
    component: SignInRoute,
});
